import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, isRef as _isRef, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_2 = { class: "flex flex-col items-center w-[30rem] mb-8" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "text-v_red w-[30rem] mt-[-1rem] pl-8 text-[0.75rem] mb-1"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-[1.3rem]" }, "Para dúvidas no acesso, clique aqui", -1)
const _hoisted_6 = ["src"]

import {
	AcessContainer,
	H1,
	H2,
	LoginInput,
	InputContainer,
	IconContainer,
	LoginButton,
} from "@/components/atoms"
import { signin } from "@/repositories/login"
import ResetPassword from "./ResetPassword.vue"
import { reactive, ref } from "vue"
import { IUser } from "@/utils/interfaces"
import router from "@/router"
import Loading from "@/components/molecules/Loading.vue"
import axios from "axios"


export default /*#__PURE__*/_defineComponent({
  __name: 'Acess',
  setup(__props) {

let user = reactive<IUser>({ username: "", password: "" })
let validationError = ref(false)
let showButton = ref(false)
let changePassword = ref(false)
let showLoading = ref(false)
let eyeIcon = ref(false)
let type = ref(false)
let errorMessage = ref("")
let count = ref(0)
let forgotPassword = ref(false)
let version = ref("carregando")
let env = ref("grey")

const login = async () => {
	showLoading.value = true
	const res: any = await signin(user)

	if (res?.status == 200) {
		router.push("/Home")
	} else if (res?.status == 403) {
		validationError.value = true
		errorMessage.value = "Username ou senha incorretos"
		showButton.value = false
		redirectUser()
	} else {
		validationError.value = true
		errorMessage.value = "Tivemos um erro inesperado"
		showButton.value = false
	}

	showLoading.value = false
}

const redirectUser = () => {
	count.value += 1

	if (count.value == 3) {
		changePassword.value = true
		count.value = 0
		forgotPassword.value = true
	}
}

const checkEmptyField = async () => {
	if (user.username !== "" && user.password !== "") {
		validationError.value = false
		showButton.value = true
	} else {
		showButton.value = false
	}
}

const showPassord = () => {
	eyeIcon.value = !eyeIcon.value
	type.value = !type.value

	let input = document.querySelector("#pass")
	if (input?.getAttribute("type") == "password") {
		input.setAttribute("type", "text")
	} else {
		input?.setAttribute("type", "password")
	}
}

const getEnv = async () => {
	const client = axios.create()

	const result = await client.get("/version")
	version.value = result.data

	console.log(version.value)
	console.log(process.env.VUE_APP_ENV)

	env.value = getColor(process.env.VUE_APP_ENV ?? "DEV")
}

const getColor = (environment: string) => {
	return (
		{
			PROD: "success",
			STAGE: "blue",
			DEV: "purple",
		}[environment] ?? "purple"
	)
}

getEnv()

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(showLoading))
      ? (_openBlock(), _createBlock(Loading, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_unref(AcessContainer), null, {
      default: _withCtx(() => [
        (!_unref(changePassword))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_unref(H1), { class: "text-v_dark_blue" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Entrar")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(H2), { class: "text-v_dark_gray mt-5" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Dentro do Portal da Comissão, você será capaz de visualizar suas comissões! ")
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_unref(InputContainer), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(LoginInput), {
                    type: "text",
                    modelValue: _unref(user).username,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(user).username) = $event)),
                    placeholder: "Username",
                    validationError: _unref(validationError),
                    onKeyup: checkEmptyField
                  }, null, 8, ["modelValue", "validationError"]),
                  _createVNode(_unref(IconContainer), { top: "3.4rem" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { icon: "mdi-account" })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(LoginInput), {
                    id: "pass",
                    type: "password",
                    modelValue: _unref(user).password,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(user).password) = $event)),
                    placeholder: "Password",
                    validationError: _unref(validationError),
                    onKeyup: checkEmptyField
                  }, null, 8, ["modelValue", "validationError"]),
                  _createVNode(_unref(IconContainer), { top: "9.9rem" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { icon: "mdi-lock" })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IconContainer), {
                    class: _normalizeClass(_unref(validationError) && 'mt-[0rem]'),
                    top: "9.9rem",
                    L: "26rem"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        idBtn: false,
                        onClick: _withModifiers(showPassord, ["prevent"]),
                        class: "active:scale-90"
                      }, [
                        _createVNode(_component_v_icon, {
                          icon: !_unref(eyeIcon) ? 'mdi-eye-outline' : 'mdi-eye-off-outline',
                          id: "eyes"
                        }, null, 8, ["icon"])
                      ], 8, _hoisted_3)
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              }),
              (_unref(validationError))
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("p", null, _toDisplayString(_unref(errorMessage)) + ". Tente novamente", 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_unref(LoginButton), {
                onClick: login,
                class: "active:scale-90",
                disabled: !_unref(showButton),
                enableButton: _unref(showButton)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Entrar ")
                ]),
                _: 1
              }, 8, ["disabled", "enableButton"]),
              _createElementVNode("button", {
                class: "text-v_green font-[700] mt-2 text-[1.5rem] active:scale-90",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_isRef(changePassword) //@ts-ignore
 ? changePassword.value = true : changePassword = true))
              }, " Esqueceu a senha? ")
            ]))
          : (_openBlock(), _createBlock(ResetPassword, {
              key: 1,
              "forgot-password": _unref(forgotPassword),
              onBackToLogin: _cache[3] || (_cache[3] = (value) =>{ _isRef(changePassword) //@ts-ignore
 ? changePassword.value = value : changePassword = value, _isRef(forgotPassword) //@ts-ignore
 ? forgotPassword.value = value : forgotPassword = value}),
              onShowLoading: _cache[4] || (_cache[4] = (value) => _isRef(showLoading) //@ts-ignore
 ? showLoading.value = value : showLoading = value)
            }, null, 8, ["forgot-password"]))
      ]),
      _: 1
    }),
    _createVNode(_component_RouterLink, {
      to: "/Duvidas",
      class: "flex w-96 justify-evenly text-v_dark_gray absolute top-[54rem] h-10 active:scale-90"
    }, {
      default: _withCtx(() => [
        _hoisted_5,
        _createVNode(_component_v_icon, { icon: "mdi-comment-question-outline" })
      ]),
      _: 1
    }),
    _createElementVNode("img", {
      class: "absolute bottom-[2.5rem] left-[2rem] text-v_dark_gray",
      alt: "Static Badge",
      src: `https://img.shields.io/static/v1?style=plastic&label=version&message=v-${_unref(version)}&color=${_unref(env)}`
    }, null, 8, _hoisted_6)
  ], 64))
}
}

})